import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("bs_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("bs_token"));

  const persist = useCallback((tok, usr) => {
    if (tok) localStorage.setItem("bs_token", tok);
    else localStorage.removeItem("bs_token");
    if (usr) localStorage.setItem("bs_user", JSON.stringify(usr));
    else localStorage.removeItem("bs_user");
    setToken(tok || null);
    setUser(usr || null);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    persist(data.token, data.user);
    return data.user;
  };

  const logout = () => persist(null, null);

  // Re-fetch profile if token exists but no user (or to validate)
  useEffect(() => {
    if (token && !user) {
      api.get("/auth/me").then(({ data }) => persist(token, data)).catch(() => persist(null, null));
    }
  }, [token, user, persist]);

  return (
    <AuthCtx.Provider value={{ user, token, login, signup, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
